export const JOB_SCREENING_METHOD = {
    ASSESSMENT_AND_AI_INTERVIEW: 'assessment_and_interview',
    ASSESSMENT_ONLY: 'assessment_only',
    AI_INTERVIEW_ONLY: 'ai_interview_only'
};